<template>
    <v-app-bar app :color="appColor" dark>
        <v-app-bar-nav-icon @click="setDrawer()"></v-app-bar-nav-icon>
        <v-toolbar-title>Residence Application Portal</v-toolbar-title>
        <v-spacer />
        <v-toolbar-title class="mr-2 subtitle-2">{{ getUserName }}</v-toolbar-title>
        <v-avatar v-if="getUserAvatar()" size="36px">
            <img class="avatar__fluid" :src="avatar" alt="avatar">
        </v-avatar>
        <v-avatar v-else :color="primaryColor" size="36px">
            {{ getUserInitials }}
        </v-avatar>
    </v-app-bar>
</template>

<script>
import auth from '../../js/auth';

export default {
    name: 'admin-toolbar',
    props: {
        drawer: {
            required: true,
            type: Boolean
        }
    },
    data() {
        return {
            avatar: '',
        }
    },
    methods: {
        getUserAvatar() {
            const user = auth.getUser();

            if (user && user.avatar) {
                this.avatar = user.avatar;
                return true;
            }

            return false;
        },
        setDrawer() {
            this.$emit('setDrawer');
        }
    },
    computed: {
        appColor() {
            return '#191b2a';
        },
        getUserInitials() {
            const user = auth.getUser().commonName.split(" ");

            if (user) {
                return `${user[0].charAt(0)}${user[1].charAt(0)}`;
            }

            return 'N/A';
        },
        getUserName() {
            return auth.getUser().commonName;
        },
        primaryColor() {
            return '#5867dd';
        }
    }
}
</script>

<style>
.avatar__fluid {
    -o-object-fit: cover;
    object-fit: cover;
}
</style>